// Clinic Configuration for Dentist In Concord
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Bloomingdale",
  clinicId: "dentistinbloomingdale",
  clinicUrl: "https://www.dentistinbloomingdaleil.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinbloomingdale&agentId=d26f3da2-091e-4bc8-8a4e-50e536953b72",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinbloomingdale/voice",

  // Contact Information
  phoneNumber: "6306861328",
  phoneNumberRaw: "+16306861328", // For tel: and sms: links
  email: "dentalcare@dentistinbloomingdaleil.com",

  // Location
  address: "366 W Army Trail Rd #310a, Bloomingdale , IL 60108, United States",
  addressShort: "366 W Army Trail Rd #310a, Bloomingdale , IL 60108, USA",
  city: "Bloomingdale",
  hcity: "Bloomingdale",
  state: "Illinois",
  stateShortForm: "IL",
  PostalCode: "60108",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/WvzNh6NsvtPbnG7g6",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d18085.761392503988!2d-88.14880768916015!3d41.9375743!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880fab0b81d48b75%3A0x8784419cb9fac87d!2sDentist%20in%20Bloomingdale!5e1!3m2!1sen!2sin!4v1759924584425!5m2!1sen!2sin',
  iframeTitle: "Dentist In Bloomingdale",

  //membership
  membership: "https://member.kleer.com/?slug=PX8B",

  // Sunbit
  sunbitUrl: "https://www.dentistinbloomingdaleil.com/patient-portal",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-bloomingdale?utm_source=practice&utm_medium=email&m=65962",


  // Analytics
  gaMeasurementId: "G-CM58Z6R2J7",
  clarityProjectId: "prdid5gc91",

  // Google Ads — direct conversion tracking
  googleAdsId: "AW-11502439341",
  googleAdsConversions: {
    // Primary — used for Smart Bidding optimization
    "phone_call_click": "AW-11502439341/Q8iLCOmizZQcEK2X5ewq",
    "contact_form_success": "AW-11502439341/p-kbCLyxwoYcEK2X5ewq",
    "call_back_success": "AW-11502439341/hSFhCIGywoYcEK2X5ewq",
    "chatbot_phone_click": "AW-11502439341/_wyQCIOOuJQcEK2X5ewq",
    "chatbot_voice_call": "AW-11502439341/AXQgCJaPuJQcEK2X5ewq",
    "book_appointment_success": "AW-11502439341/6BIfCK-et4YcEK2X5ewq",
    "Confirm-Booking": "AW-11502439341/nRveCKijzZQcEK2X5ewq",
    "Submit-Payment": "AW-11502439341/Lx3dCNv4w5QcEK2X5ewq",
    // Secondary — observation/reporting only
    "sms_click": "AW-11502439341/xJiUCNeizZQcEK2X5ewq",
    "directions_click": "AW-11502439341/NlvMCL6hzZQcEK2X5ewq",
    "email_click": "AW-11502439341/f4fkCN74w5QcEK2X5ewq",
    "map_click": "AW-11502439341/DaWZCOCizZQcEK2X5ewq",
    "social_media_click": "AW-11502439341/v9uCCOaizZQcEK2X5ewq",
    "financing_click": "AW-11502439341/Y9TGCOjtw5QcEK2X5ewq",
    "membership_click": "AW-11502439341/CEPQCPuizZQcEK2X5ewq",
    "outbound_link_click": "AW-11502439341/HVBxCLWNuJQcEK2X5ewq",
    "chat_send": "AW-11502439341/D1ppCP6izZQcEK2X5ewq",
    "chatbot_quick_action": "AW-11502439341/mwHgCPqNuJQcEK2X5ewq",
    "chatbot_insurance_upload": "AW-11502439341/ymJNCLuNuJQcEK2X5ewq",
  } as Record<string, string>,

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinbloomingdale",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinbloomingdale",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinbloomingdale",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistinbloomingdaleil.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/DentistinBloomingDale",
    instagram: "https://www.instagram.com/stories/dentistinbloomingdale/",
    twitter: "https://x.com/DentistBlooming",
    linkedin: "https://www.linkedin.com/company/107867969/admin/",
    youtube: "https://www.youtube.com/@Dentistinbloomingdale",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/9050281790021140375/profile?hl=en-GB&fid=9765002033437001853",
    facebook: "https://www.facebook.com/dentistinbloomingdale.official/",
    yelp: "https://www.yelp.com/biz/dentist-in-bloomingdale-bloomingdale?osq=dentist+in+bloomingdale",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 11,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 9,
      AppointmentTypeNum: 14
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 17
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 12
    }
  ],


  // Twilio Configuration
  twilioPhoneNumber: "16307930375",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;

